export default {
  seeMore: {
    id: 'article_cards_collection_see_more',
    defaultMessage: 'See all articles',
  },
  seeLess: {
    id: 'article_cards_collection_see_less',
    defaultMessage: 'Hide articles',
  },
} as const
